import { client } from "@/config/client"

export interface SpecialDeck {
  id: string
  question: string
  answer: string
  activityId: string
  timesViewed: number
  nextReview: string
}

export interface GetSpecialDeckResponse {
  description: SpecialDeck[]
}

interface GetSpecialDeckParams {
  learningPathId: string
}

export default function getSpecialDeck(params: GetSpecialDeckParams) {
  return client.get<GetSpecialDeckResponse>(`/v1/flashcards/special-deck`, { params })
}
